import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import TituloComponent from '../../components/Titulo/TituloComponent';
// css
import '../../styles/global.css';
import './GerarQrCodeMesa.css';
import GerarQrCodeMesaComponent from '../../components/GerarQrCodeMesaComponent/GerarQrCodeMesaComponent';
// cookies
import Cookies from 'js-cookie';

const GerarQrCodeMesa = () => {
  const navigate = useNavigate();

  // pegar todos os dados dos cookies
  const allCookies = getAllCookies();
    
  // Pega os dados da sessão diretamente
  const userData = JSON.parse(sessionStorage.getItem('userData')); // Assume que os dados estão armazenados no sessionStorage

  // precisaremos passar o idEstabelecimento  para o componente
  const [idEstabelecimento, setIdEstabelecimento] = useState(null);

  const [formData, setFormData] = useState({
      numeroMesa: "",
  });

  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const qrCodeRef = useRef(null);

    useEffect(() => {
      console.log('Entrou em GerarQrCodeMesa...');

      console.log('Verificando status do usuário na sessão...');
      if (userData) {
          try {
              if (userData.statusUsuario === 'logado') {
                  console.log('Dados do usuário na sessão:', userData);

                  // vamos pegar o idEstabelecimento para passá-lo para o componente
                  const idEstabelecimento = userData.dadosEstabelecimento.id;
                  setIdEstabelecimento(idEstabelecimento);

                  console.log('Dados do estabelecimento: ');
                  console.log(userData.dadosEstabelecimento);

              } else {
                  console.log('Usuário não está logado.');
              }
          } catch (error) {
              console.error('Erro ao parsear os dados de usuário:', error);
          }
      } else {
          console.log('Usuário NÃO está logado!');
      }
  }, [navigate]);

  const handleSubmit = (e) => {
    console.log('Entrou no handleSubmit do GerarQrCodeMesa...');

    e.preventDefault();
    const numeroMesa = formData.numeroMesa;
  
    // Aqui você define a URL que será codificada no QR Code
    // const url = `${window.location.origin}/checkin-mesa/${numeroMesa}`;
    const url = `/atualizar-checkin-qrcodemesa/${numeroMesa}`;    
  
    console.log('URL do QR Code:', url);
    setQrCodeUrl(url);
  };
  
  function getAllCookies() {
    return document.cookie.split(';').reduce((cookies, cookie) => {
      const [name, value] = cookie.split('=');
      cookies[name.trim()] = decodeURIComponent(value);
      return cookies;
    }, {});
  }
  

  return (
    <div autoFocus className="bar-gerente-container">
        <TituloComponent />
        <form onSubmit={handleSubmit}>
          <h2 className="form-title">Gerar QR Code</h2>

          <div className="box-dados">
              <p className="texto-welcome">Você está em { userData.dadosEstabelecimento.nome }!</p>
          </div>

          {/* <GerarQrCodeMesaComponent /> */}
          <GerarQrCodeMesaComponent idEstabelecimento={idEstabelecimento} />


        </form>

    </div>
  );
};

export default GerarQrCodeMesa;
